import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
export function VenturesPage() {
  const ventures = [{
    id: 9,
    title: 'Sapis Capital Group',
    description: 'Empowering exceptional companies with the resources and expertise to achieve sustainable long-term success. Founded in 2024, at Sapis Capital Group, we believe in forging lasting partnerships with visionary entrepreneurs and management teams. Our investment philosophy centers on sustainable growth, ethical business practices, and innovative approaches to value creation.',
    role: 'Founder',
    year: '2024 - Ongoing',
    link: 'https://sapiscapitalgroup.com/',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ouiAmf5QvzLpVtE1bHB5Y8/gfbgbfgf.jpg'
  }, {
    id: 1,
    title: 'Culture Whiz',
    description: "Culture whiz is your cultural and social guide to the world. It is where you can examine the connections between the behavior of individuals and the structures of society in which they live. If you have travelled a considerable amount of time, it can open your eyes to a larger world; giving you the opportunity to dig deeper into a country, a city, a culture. It's where you can, not only, learn more about the world and people surrounding you, but about yourself as well. This is Culture whiz, an up-to-date and reliable worldwide resource guide.",
    role: 'Founder',
    year: 'Ongoing',
    link: 'http://culturewhiz.org',
    imageUrl: ''
  }, {
    id: 2,
    title: 'Language Circle',
    description: "Language Circle offers a social community to engage with and learn from people across the globe through new friendships, language practice, and cultural understanding for work, travel and friendships that will enrich your life. On this platform, you can host an international get-together, chat with certified translators and verified travel hosts, and even win airline tickets abroad. It's fun, practical and an engaging way to learn about your world - through people!",
    role: 'Founder',
    year: 'Ongoing',
    link: 'http://languagecircle.org',
    imageUrl: ''
  }, {
    id: 3,
    title: 'Alahah Properties',
    description: 'Alahah Properties is a multi-faceted real estate investment, management and development company with a portfolio of commercial, residential, land, hostels and resorts that span the world.',
    role: 'Founder & CEO',
    year: 'Ongoing',
    link: 'http://alahahproperties.com',
    imageUrl: ''
  }, {
    id: 4,
    title: 'SyNeural',
    description: "SyNeural is the world's first digital media company producing infrastructure platforms for the next generation of the Web. In just a few shorts years, what we currently understand as the web will be replaced by Semantic Repositories that enable new applications that can effectively manage our lives and business.",
    role: 'Founder',
    year: 'Ongoing',
    link: 'http://www.SyNeural.com',
    imageUrl: ''
  }, {
    id: 5,
    title: 'Trust Circle Networks',
    description: 'Trust Circle Networks, Inc is a network of carefully vetted service providers from around the world. Trust Circle Networks eliminates the difficulty and stress of the service-search by offering only professionally prescreened service providers. The providers, which range from moving services to dentist, all go through a professional prescreening security process.',
    role: 'Founder',
    year: 'Ongoing',
    link: 'http://trustcirclenetworks.org',
    imageUrl: ''
  }, {
    id: 6,
    title: 'Town Source',
    description: 'TownSource, a new type of web site that has a Semantic Repository of information about a neighborhood, town, or city. Fed by information contributed by its users, a TownSource repository comes to represent all aspects of the community and the relationships among them. By combining the ability for users to create their own content, via an innovative wiki, employing language processing (NLP), the creation of a highly relevant information source covering nearly everything is fostered.',
    role: 'Founder',
    year: 'Ongoing',
    link: 'http://www.townsource.org',
    imageUrl: ''
  }, {
    id: 7,
    title: 'University Student Movers',
    description: 'UniversityStudentMovers.org is a directory of hand-selected independent student-run moving companies rated and ranked by our customers after each move. You can read numerous reviews, compare prices, ratings, etc. University Student Movers currently operates nationwide with 29 locations in 21 states.',
    role: 'Founder',
    year: 'Ongoing',
    link: 'http://www.universitystudentmovers.org',
    imageUrl: ''
  }, {
    id: 8,
    title: 'California Institute for Microbiome Research (CalMiR)',
    description: 'The California Institute for Microbiome Research (CalMiR) is an independent, science-first research institute founded in 2024 and dedicated to applying pharmaceutical-grade rigor to microbiome and wellness science. CalMiR operates at the center of a four-part ecosystem, creating a closed loop of science → validation → productization → adoption.',
    role: 'Founder',
    year: '2024 - Ongoing',
    link: 'https://calmir.org/',
    imageUrl: ''
  }];
  return <div className="w-full bg-white" data-id="element-675">
      <div className="container mx-auto px-4 py-16" data-id="element-676">
        <div className="max-w-4xl mx-auto" data-id="element-677">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-678">
            Ventures & Projects
          </h1>
          <p className="text-lg text-gray-700 mb-12" data-id="element-679">
            Explore my entrepreneurial journey and the businesses, startups, and
            projects I've been involved with.
          </p>
          <div className="space-y-16" data-id="element-680">
            {ventures.map(venture => <div key={venture.id} className="md:flex items-start gap-8" data-id="element-681">
                {venture.imageUrl ? <div className="md:w-1/3 mb-6 md:mb-0 flex items-center justify-center bg-white rounded-lg" data-id="element-682">
                    <img src={venture.imageUrl} alt={`${venture.title} logo`} className="max-w-full max-h-full object-contain rounded-lg" data-id="element-683" />
                  </div> : <div className="md:w-1/3 aspect-square bg-gray-200 rounded-lg mb-6 md:mb-0" data-id="element-684"></div>}
                <div className="md:w-2/3" data-id="element-685">
                  <div className="flex items-start justify-between mb-2" data-id="element-686">
                    <h2 className="text-2xl font-semibold text-gray-900" data-id="element-687">
                      {venture.title}
                    </h2>
                    {venture.link && <a href={venture.link} className="text-blue-600 hover:text-blue-800" target="_blank" rel="noopener noreferrer" data-id="element-688">
                        <ExternalLinkIcon className="h-5 w-5" data-id="element-689" />
                      </a>}
                  </div>
                  <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-690">
                    <span className="font-medium text-gray-700" data-id="element-691">
                      {venture.role}
                    </span>
                    <span className="mx-2" data-id="element-692">•</span>
                    <span data-id="element-693">{venture.year}</span>
                  </div>
                  <p className="text-gray-700 mb-6" data-id="element-694">{venture.description}</p>
                  {venture.link && <a href={venture.link} className="inline-flex items-center text-blue-600 font-medium hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-695">
                      Visit website{' '}
                      <ExternalLinkIcon className="ml-2 h-4 w-4" data-id="element-696" />
                    </a>}
                </div>
              </div>)}
          </div>
          <div className="mt-16 bg-gray-50 rounded-lg p-8 border border-gray-200" data-id="element-697">
            <h2 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-698">
              Interested in Collaboration?
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-699">
              I'm always open to discussing new ventures, partnerships, and
              investment opportunities that align with my interests and values.
            </p>
            <a href="/contact" className="inline-block px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors" data-id="element-700">
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </div>;
}